module.exports = __webpack_public_path__ + "img/deadlines-mobile.c530e5ce.png";